/* eslint-disable react/no-unescaped-entities */
import {
  Box,
  Flex,
  Heading,
  HStack,
  Icon,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { FiHelpCircle } from "react-icons/fi";

const PricingFAQ = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      mt={8}
      bg={colorMode === "light" ? "white" : "neutral.800"}
      borderRadius="2xl"
      p={{ base: 8, md: 10 }}
      boxShadow={
        colorMode === "light"
          ? "0 10px 40px rgba(0, 0, 0, 0.08)"
          : "0 10px 40px rgba(0, 0, 0, 0.3)"
      }
      border="1px solid"
      borderColor={colorMode === "light" ? "neutral.100" : "neutral.800"}
    >
      <HStack spacing={4} mb={4}>
        <Flex
          w={12}
          h={12}
          bg={colorMode === "light" ? "orange.50" : "rgba(255, 79, 0, 0.1)"}
          borderRadius="xl"
          align="center"
          justify="center"
        >
          <Icon
            as={FiHelpCircle}
            boxSize={6}
            color="brand.500"
            aria-hidden="true"
          />
        </Flex>
        <Heading
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight={700}
          color={
            colorMode === "light" ? "text.light-primary" : "text.dark-primary"
          }
        >
          Does Adiona Alert work with my device?
        </Heading>
      </HStack>
      <Text
        color={
          colorMode === "light" ? "text.light-secondary" : "text.dark-muted"
        }
        fontSize="md"
        lineHeight="1.8"
        ml={{ md: 16 }}
      >
        Adiona Alert Premium currently supports Garmin inReach, ZOLEO, and Bivy
        Stick devices. We're actively working to add support for more devices in
        the near future.
      </Text>
    </Box>
  );
};

export default PricingFAQ;
